import { Ref, forwardRef } from 'react'

import styles from './CheckBoxInput.module.scss'
import { InputProps } from '../Input/input-types'
import { InputBase } from '../Input/InputBase'
import Label from '../Label'

function CheckBox(props: InputProps, ref: Ref<HTMLInputElement>) {
    return (
        <Label className={styles.label}>
            <InputBase
                {...props}
                ref={ref}
                inputContainerClassName={styles.checkBoxContainer}
                inputClassName={styles.input}
                type="checkbox"
            >
                <span className={styles.checkbox} />
            </InputBase>
            <span>{props.children}</span>
        </Label>
    )
}

export const CheckBoxInput = forwardRef(CheckBox)
